







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class WaterConsentConditionModalTitle extends Vue {
	@Prop()
	public title?: string | null;

	@Prop()
	public description?: string | null;
}
